import Grid from "@mui/material/Grid2";
import { OLButton } from "OLButton";
import { CustomAttribute } from "components/CustomAttributesSection/CustomAttribute";
import { EmptyState } from "components/EmptyState/EmptyState";
import { ReactComponent as CodeSquare02Icon } from "components/Icons/code-square-02.svg";
import { FieldArray } from "formik";
import { useMessage } from "hooks/intl";
import { KeyValuePair } from "utilities/objects";

interface Props {
  labels: KeyValuePair[];
  name?: string;
}

export const CustomAttributesSection = ({ labels, name }: Props) => {
  const { message } = useMessage();

  const isAnyLabelAdded = labels && labels.length > 0;

  return (
    <FieldArray
      name={name ? `${name}.labels` : "labels"}
      render={(arrayHelpers) => (
        <>
          {isAnyLabelAdded ? (
            <Grid container rowSpacing={12} columnSpacing={16} data-hj-suppress>
              {labels?.map((_attr, index) => {
                return (
                  <CustomAttribute
                    remove={arrayHelpers.remove}
                    index={index}
                    key={index}
                    name={name ? `${name}.labels[${index}]` : `labels.${index}`}
                  />
                );
              })}
              <Grid size={{ xs: 12 }}>
                <OLButton
                  variant="contained"
                  type="button"
                  onClick={() => arrayHelpers.push({ key: "", value: "" })}
                >
                  {message({ id: "newCustomAttribute" })}
                </OLButton>
              </Grid>
            </Grid>
          ) : (
            <EmptyState
              icon={<CodeSquare02Icon />}
              title={message({ id: "addFirstCustomAttribute" })}
              description={message({ id: "customAttributeDescription" })}
              button={
                <OLButton
                  color="primary"
                  onClick={() => arrayHelpers.push({ key: "", value: "" })}
                  variant="outlined"
                  size="medium"
                  data-test-id="new-custom-attribute"
                >
                  {message({ id: "newCustomAttribute" })}
                </OLButton>
              }
            />
          )}
        </>
      )}
    />
  );
};
